import { h } from "preact";
import { useState } from "preact/hooks";
import { vpImage, NotFoundStyle } from "./Image.css";
import { PluginItemContentType, } from "../../types/PluginItem.interface";
import { DisplayTypes } from "../../types/Display.interface";
var NOT_FOUND_URL = "https://videopeel-assests.s3.amazonaws.com/production/FallBackImage.png";
var Image = function (_a) {
    var _b = _a.className, className = _b === void 0 ? "" : _b, item = _a.item, onClickPlayHandler = _a.onClickPlayHandler, _c = _a.style, style = _c === void 0 ? {} : _c, _d = _a.onLoadError, onLoadError = _d === void 0 ? function () { } : _d;
    var isVideoContent = (item === null || item === void 0 ? void 0 : item.contentType) === PluginItemContentType.VIDEO;
    var href = item === null || item === void 0 ? void 0 : item.href;
    var _e = useState(isVideoContent ? item === null || item === void 0 ? void 0 : item.thumbnail : href), imageSrc = _e[0], setImageSrc = _e[1];
    return (imageSrc ? (h("img", { className: vpImage + " " + className, src: imageSrc, onClick: function () {
            onClickPlayHandler(isVideoContent ? DisplayTypes.VIDEO : DisplayTypes.IMAGE, href);
        }, style: style, onError: function () {
            setImageSrc("");
            onLoadError();
        } })) : (h("img", { className: NotFoundStyle + " " + className, src: NOT_FOUND_URL, style: style })));
};
export default Image;
